// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';

export const ProposedTag = zod.object({
  "id": zod.union([zod.uuid(),zod.null()]),
  "name": zod.string(),
  "source": ProposalSource
});

export type ProposedTag = zod.input<typeof ProposedTag>;
export type ProposedTagOutput = zod.output<typeof ProposedTag>;
